import { render } from "./Manuale.vue?vue&type=template&id=d6e706a6&scoped=true"
import script from "./Manuale.vue?vue&type=script&lang=js"
export * from "./Manuale.vue?vue&type=script&lang=js"

import "./Manuale.vue?vue&type=style&index=0&id=d6e706a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e706a6"]])

export default __exports__